export default "__VITE_ASSET__6f88b967__"